var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/InputErrorField/index.tsx";
import React, { memo } from 'react';
import { HStack, Stack } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';
import { RichText } from 'Components/utility';
const InputErrorField = ({
  testID,
  errorMessage
}) => {
  if (!errorMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement(HStack, {
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    marginRight: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(IconValidationInvalid, {
    color: "$support.danger.surfaceOnColorAlt",
    testID: `${testID}-icon`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(RichText, {
    color: "$support.danger.surfaceOnColorAlt",
    fontToken: "$bodySmall.default",
    testID: `${testID}-errorMessage`,
    text: errorMessage,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }));
};
export default /*#__PURE__*/memo(InputErrorField);